import { Link } from '@acpaas-ui/react-components';
import { useSelector } from 'react-redux';
import { FORM_COMPOSER_HOST } from '../../../constants/settings.constants';
import { envSelector } from '../../../selectors/auth.selectors';
import SelectField from '../../forms/SelectField';

const FormPicker = ({ isRepresentative, formOptions = [], disabled, isSubmitting, onChange, onClose, data }) => {
  const env = useSelector(envSelector);

  if (!isRepresentative) {
    return null;
  }

  return (
    <div className="spo-o-dossier-casetafel-questionnaire__form-picker">
      <div className="u-padding row">
        <div className="col-xs-12 col-lg-6">
          <SelectField
            options={[...formOptions]}
            disabled={disabled}
            onChange={onChange}
            onClose={onClose}
            value={data?.formSlug}
            isSubmitting={isSubmitting}
            label={
              <span>
                Formulier uit{' '}
                {
                  <Link href={FORM_COMPOSER_HOST?.[env] ?? '#'} target="_blank">
                    Formcomposer
                  </Link>
                }
              </span>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default FormPicker;
